/**
 * Created by areynolds2 on 12/12/2016.
 */

//PAGE NAMESPACE
var fpb = {};

//Functions called used by scripting, not bound to html components events
fpb.fns = {};

//Functions tied to html components
fpb.html = {};

//Define a Payload Class
var PayLoad = function(){
    //var pages = [];
    var pages = [];

    this.get = function(){
        return {
            pages : pages,
            objectGID : $('#globalIdentifier').val(),
            fefVersion : $('#fefVersion').val(),
            wizardArchetype : $('#wizardApp').is(':checked')
        };
    };

    this.isWizardApp = function(){
        return $('#wizardApp').is(':checked');
    };

    this.addPage = function(p){
        pages.push(p);
        return p;
    };

    this.getLastPageAddedIndex = function(){
        return pages.length - 1;
    };

    this.getPage = function(indx){
        if( pages[indx] ){
            return pages[indx]
        } else{
            console.log('Page ' + indx + ' is not defined');
            return null;
        }
    };

    this.addSection = function(sec , pageIndx ){
        if( ! pages[pageIndx] ){
            throw new Error('Attempting to attach a section an undefined page')
        }
        if( ! pages[pageIndx].sections ){
            pages[pageIndx].sections = [];
        }
        //Set skey
        sec.skey = 'pk' + pages[pageIndx].sections.length;
        if( ! sec.name ){
            sec.name = 'section' + pages[pageIndx].sections.length;
        }
        pages[pageIndx].sections.push( sec );
        return sec;
    };

    this.getSection = function(sectionKey , pageIndx){
        if( ! pages[pageIndx] ){
            throw new Error('Attempting to attach a section an undefined page')
        }
        if( ! pages[pageIndx].sections ){
            throw new Error('Section doesnt exist');
        }
        for(var i = 0 ; i < pages[pageIndx].sections.length ; i++ ){
            var section = pages[pageIndx].sections[i];
            if(section.skey == sectionKey ){
                return section;
            }
        }
    };
    this.addSectionComponent = function( skey, pindx , comp ){
       var section = this.getSection(skey , pindx );
       if( ! section ){
           throw new Error('Section does not exist with key ' + skey );
       }
       if( ! section.components ){
           section.components = [];
       }
       comp.pk = 'c' + section.components.length;
       section.components.push( comp );
    };

    this.getSectionComponents = function( skey , pindx ){
        var section = this.getSection(skey , pindx );
        return section.components;
    };
    this.getSectionComponent = function( skey , pindx , cindx ){
        var sectionComponents = this.getSectionComponents( skey , pindx );
        var component;
        sectionComponents.forEach(function(item){
            if( item.pk == cindx ){
                component = item;
                return true;
            }
        })
        return component;
    };

    this.deleteComponentFromSection = function( skey , pindx, compId ){
        var section = this.getSection(skey, pindx );
        var components = section.components;
        var index;
        components.forEach(function(item, i){
            if( item.pk == compId ){
                index = i;
            }
        });
        if(index != undefined ){
            components.slice(index, 1 );
        } else {
            throw new Error('Could not find component with id ' + compId + ' for section ' + skey );
        }
    };
    /*
        Wraps the pages array in a data schema format that kendoTreeview understands
     */
    this.getPagesForTreeDataSource = function() {
        var ds = [];
        var childrenArrays = ['components' , 'sections'];
        for(var i = 0 ; i < pages.length; i++ ){
            var node = { text : pages[i].name , items : [] , header : true , index : i };
            ds[i] = node;
            this.formTreeModelSchema( pages[i] , node.items , childrenArrays , true );
        }
        return ds;
    }

    this.formTreeModelSchema = function( src, dest , arr , ignorePageName ){
        //Lowest level
        if( src.hasOwnProperty('type') ){
            var node = {text: src['type'] , items : [] };
            for( var pr in src ){
                if( src.hasOwnProperty(pr) && pr != 'pk' && pr != 'type'){
                    node.items.push( { key : pr , val : src[pr] })
                }
            }
            dest.push( node );
            return;
        }

        for( var pr in src ){
            if( src.hasOwnProperty(pr) ){
                if( arr.indexOf(pr) > -1 ){
                    dest.push( { text : pr , items : [] });
                    var len = dest.length - 1;
                    var componentArray = src[pr];
                    for(var i = 0 ; i < componentArray.length ; i++ ){
                        this.formTreeModelSchema( componentArray[i] , dest [ len ].items , arr);
                    }
                } else{
                    //ignore page name for name at page level
                    //also ignore section and component keys - pk and skey
                    if( ( ! ( ignorePageName && pr == 'name' ) ) &&
                        pr != 'pk' && pr != 'skey' ){
                        dest.push( { key : pr , val : src[pr] } );
                    }
                }
            }
        }
    }
};

fpb.payload = new PayLoad();

//tabstrip kendoTabstrip object wrapper
fpb.aceEditor;
//Hold object schema
    //fields - [] - list of singular fields
    //embedded - [] - list of embedded objects
    //embedded_map {} - key/value of array of embbedded object pair
fpb.objectSchema = {
    fields : null, lists : null , listFields : null
};

//Keep track of 'active' components index to show on UI
//Example - section 0 is active, meaning its displayed on screen
fpb.activeIndx = {
    //TESTING
    //PAGE : 0
    //SECTION
    //COMPONENT
};

fpb.ready = function() {

    //INITs Soho Components
    $('.tab-container').tabs();
    $('#fefVersion').dropdown();
    $('#fefComponents').dropdown();
    var tabContainer = $('.tab-container');
    tabContainer.on('afteractivated' , function(i){
        //for tab 3 - some initialization code
        if( $(this).data('tabs').getActiveTab().attr('href') == '#tabs-three'){
            fpb.fns.initFefPageTab();
        }
    });

    fpb.aceEditor = ace.edit('objectSchema');
    fpb.aceEditor.getSession().setMode("ace/mode/json");
    fpb.aceEditor.session.setUseWorker(false);

    $("#sectionList").kendoSortable({
        handler : '.fa-sortable-handler',
        placeholder: fpb.dragDropPlaceholderMsg
    });

    $('#sectionComponentList').kendoSortable({
       handler : '.fa-sortable-handler',
        placeholder : fpb.dragDropPlaceholderMsg,
        move : function(el){
           console.log('moving');
        },
        end : fpb.fns.sortSectionComponents
    });

    $('#wizardAppTooltip').tooltip({ placement : 'right' } );

    $('#pageTree').kendoTreeView({
        animation : false,
        dataSource : fpb.payload.getPagesForTreeDataSource() ,
        template : kendo.template($("#treeview-template").html()),
        select : function(el){
            el.preventDefault();
            this.select( el.node );
            this.toggle( el.node );
            $( el.node).find('.k-state-selected').removeClass('k-state-selected');
        }
    })
};

//Define functions attached to HTML

/*
    On continue button click - go to next tab
 */
fpb.html.continueBtnClick = function(element) {
    var tabs = $(element).parents('.tab-container');
    var this_tab_id = '#' + $(element).parents('[role="tabpanel"]').attr('id');

    //Find and activate next tab
    var next_tab_index = tabs.children(this_tab_id).index() + 1 ;
    var next_tab_id = '#' + tabs.children().eq(next_tab_index).attr('id');
    tabs.data('tabs').activate(next_tab_id);
    tabs.data('tabs').enableTab(next_tab_id);
};

/*
    On first tab - only enable continueBtn
 */
fpb.html.enableContinueBtn = function(el){
    var $input = $(el);
    var $continueBtn = $input.parents('#tabs-one').find('.btn-primary');
    $input.val() ? $continueBtn.removeAttr('disabled') : $continueBtn.attr('disabled' , 'true');
};
/*
    On back btn click - go to previous tab
 */
fpb.html.backBtnClick = function(element){
    var tabs = $(element).parents('.tab-container');
    var this_tab_id = '#' + $(element).parents('[role="tabpanel"]').attr('id');

    //Find and activate next tab
    var next_tab_index = tabs.children(this_tab_id).index() - 1 ;
    var next_tab_id = '#' + tabs.children().eq(next_tab_index).attr('id');
    tabs.data('tabs').activate(next_tab_id);
    tabs.data('tabs').enableTab(next_tab_id);
};

/*
    Add section to the active page in the paylod
    Set the added section to be the editable section
 */
fpb.html.addSectionBtnClick = function(){
    //Add to payload
    var addedSection = fpb.payload.addSection( {
        name : $('#sectionName').val() ,
        label : $('#sectionLabel').val()
    } , fpb.activeIndx.PAGE );
    //SHOW ON UI
    $('#sectionDefinition').show();
    var sectionsList = $('ul.fa-page-sections');

    //ADD SECTION TO UI
    var addSection = $('<li class="fa-sortable-list-item" skey="' + addedSection.skey + '" onclick="fpb.activateSection(this)"><span class="fa-sortable-handler"></span>'+ addedSection.name + '</li>');
    sectionsList.append(addSection);

    //Clear section inputs
    $('input#sectionName , input#sectionLabel').val('');
    //Click the newly added list-item - this will activate the section
    sectionsList.find('li:last-child').click();
    $('#componentDetailDiv').hide();
};

/*
    Pass in list item - remove the css class from all items
    then add it to the one element
 */
fpb.setActiveListItem = function(el , css_active_class ){
    $(el).parent().find('li').each(function(i , li){
        $(li).removeClass(css_active_class);
    });
    $(el).addClass(css_active_class);
};

fpb.activateSection = function(el){
    fpb.setActiveListItem(el , 'fa-section-active');
    var sectionkey = $(el).attr('skey');
    var activeSection = fpb.payload.getSection( sectionkey , fpb.activeIndx.PAGE );
    fpb.activeIndx.SECTION = sectionkey;

    //CHANGE HTML OF ACTIVE SECTION
    var $activeSectionHtml = $(el).parents('#sections').find('#active-section');
    $activeSectionHtml.find('#sectionNameValue').text( activeSection.name );
    $activeSectionHtml.find('#sectionLabelValue').text( activeSection.label );
    fpb.fns.setSectionComponents(el);
};

fpb.createZip = function() {
    var tab_section = $('#completeTab');
    tab_section.busyindicator({ text: 'Creating FEF Archive...' , displayDelay : 0 } ).trigger('start.busyindicator');

    var payload = fpb.payload.get();

    payload._csrf = global_defined_var._csrf;
    var xhr = new XMLHttpRequest();
    xhr.open('POST' , '/dev/fef-archetype-zip');
    xhr.setRequestHeader('Content-type' , 'application/json');
    xhr.responseType = 'blob';
    xhr.onload = function(data){
        console.log(this.response || data);
        var file = URL.createObjectURL(this.response || data);
        //window.open(file);
        $('#downloadFEFZipLink').attr('href' , file )
            .attr('download' , 'FEFBundle.zip');
        $('#complete_success').show();
        tab_section.trigger('updated.busyindicator');
    };
    xhr.onerror =  () => {
        console.log('failure');
        tab_section.trigger('updated.busyindicator');
    };

    xhr.send(JSON.stringify(payload));
};

/*
    OnClick Event for X span which is in top-right of component list item
    Remove this list item from the UI and remove the component from the underlying section
    payload
    @el - element - delete-component-btn <span/>
 */
fpb.deleteComponentFromSection = function(el){
    var $listItem = $(el).parents('li.fa-sortable-list-item');
    var componentId = $listItem.attr('pk');
    fpb.payload.deleteComponentFromSection(fpb.activeIndx.SECTION , fpb.activeIndx.PAGE , componentId );
    $listItem.remove();
};


fpb.addPage = function(){
    var page = fpb.payload.addPage({
        name : $('#pageName').val(),
        title : $('#pageTitle').val(),
        initialEditMode : $("input[name='initialEditMode']").filter(':checked').val(),
        editToggle : $("input[name='editToggle']").filter(':checked').val(),
        includeDocbar : $('#includeDocbar').is(':checked') ? 'yes' : 'no',
        startingPage : $('#startingPage').is(':checked') ? 'true' : 'false'
    });

    //If no name - assign name
    if( ! page.name ){
        page.name = 'page' + ( fpb.payload.getLastPageAddedIndex() + 1 )
    }

    fpb.fns.setEditablePage(page);
};

/*
    Set the editable div on the UI to be the active page
 */
fpb.fns.setEditablePage = function(page , indx ){
    var $section = $('#activePageDefinition');

    $section.find('h1:first-child').text( page.name );
    $section.find('#pageTitle').text( page.title );
    $section.find('#pageDocbar').text( page.includeDocbar );
    $section.find('#pageIEM').text( page.initialEditMode );
    $section.find('#pageET').text( page.editToggle );
    $section.find('#pageSP').text( page.startingPage );
    //set page as active
    fpb.activeIndx.PAGE = indx || fpb.payload.getLastPageAddedIndex();
    fpb.fns.setTabThreeMode('EDITABLE');
    $('#sectionDefinition').hide();
    fpb.fns.setPageSections( page );
};

fpb.fns.setPageSections = function( page ){
    var $list = $('ul.fa-page-sections');
    $list.find('li').remove();
    if( ! ( page.sections && page.sections.length ) ) return;
    $('#sectionDefinition').show();
    page.sections.forEach(function(section){
        $list.append('<li class="fa-sortable-list-item" skey="' + section.skey + '" onclick="fpb.activateSection(this)"><span class="fa-sortable-handler"></span>'+ section.name + '</li>')
    });
    $list.find('li').get(0).click();
};

fpb.html.importObject = function(){
    var schema;
    var schema_error = $('#schemaError').hide();
    var schema_succ = $('#schemaSuccess').hide();
    try{
        schema_succ.show();
        schema = JSON.parse(fpb.aceEditor.getValue());
        fpb.fns.parseObjectSchema(schema);
    }catch(err){
        schema_error.show();
    }
};

fpb.dragDropPlaceholderMsg = function (el) {
    return $("<li class='fa-sortable-list-item' id='placeholder'>Drop Here!</li>");
};

fpb.fns.setSectionComponents = function(el){
    //clear component list
    var $componentList = $(el).parents('#sections').find('ul.fa-section-components').empty();

    var sectionComponents = fpb.payload.getSectionComponents( $(el).attr('skey') , fpb.activeIndx.PAGE ) || [];
    //noinspection JSAnnotator
    sectionComponents.forEach( function(component ){
        fpb.fns.addComponentToSectionUI( $componentList , component );
    })
    if( $componentList.find('li').get(0) ){
        $componentList.find('li').get(0).click();
    }
};

fpb.fns.addComponentToSection = function( el , component ){
    fpb.payload.addSectionComponent(fpb.activeIndx.SECTION ,fpb.activeIndx.PAGE , component );
    fpb.fns.addComponentToSectionUI( $(el).parents('#sectionDefinition').find('ul.fa-section-components') , component );
    fpb.fns.clearInputs( $(el).parent() );
};

fpb.fns.addComponentToSectionUI = function( $list , component ){
    //Either update a component or add a new one
    var newComponent = true ,
        $componentItem;
    $list.find('li').each( function(){
        if( $(this).attr('pk') == component.pk ){
            $componentItem = $(this);
            $componentItem.find('.props-div').empty();
            newComponent = false;
            return true;
        }
    });

    if( newComponent ){
        $componentItem = $('<li class="fa-sortable-list-item" pk="' + component.pk + '"><span class="fa-sortable-handler"></span></li>')
            .click( fpb.componentMasterRowClickFn );
        var $h4 = $('<h4 style="margin-bottom:16px;">' + component.type + '<span class="fa-component-delete-btn" onclick="fpb.deleteComponentFromSection(this)"><span class="k-icon k-i-close"></span></span>');
        $componentItem.append($h4);
        $componentItem.append('<div class="props-div"/>');
        $list.append($componentItem);
        fpb.setActiveListItem($componentItem , 'fa-component-active');
    }
    var $propDiv = $componentItem.find('.props-div');

    for(var prop in component){
        if( component.hasOwnProperty(prop) && prop != 'type' && prop != 'pk'){
            $propDiv.append('<span class="entity-name">' + fpb.kvMap[prop] + '</span> : ')
                .append('<span class="fa-inline-code">' + component[prop] + '</span><br/>');
        }
    }
};

fpb.componentMasterRowClickFn = function(e){
    var $target = $(e.target);
    //If you click on sortable icon or delete btn , ignore
    if( $target.hasClass('fa-sortable-handler') || $target.hasClass('k-i-close') ){
        return;
    }
    var $li = $( e.currentTarget );

    var key = $li.attr('pk');
    var active_component = fpb.payload.getSectionComponent( fpb.activeIndx.SECTION , fpb.activeIndx.PAGE , key );
    //init component detail
    fpb.fns.setComponentDetail( active_component.type , 'Update Component' );
    //Prefile component detail
    fpb.fns.prefillComponentDetail( active_component );
    fpb.activeIndx.COMPONENT = key ;
    fpb.setActiveListItem($li , 'fa-component-active');
    $('#componentDetailDiv').show()
};

fpb.fns.prefillComponentDetail = function( component ){
    $('#componentDetail')
        .find('input,select')
        .each(function(){
            var $this = $(this);
            var id = $this.attr('id');
            if( component[id] ){
                if( $this.is('input') ){
                    switch( $this.attr('type') ){
                        case 'text' :
                            $this.val( component[id] );
                            break;
                        case 'checkbox' :
                            $this.attr('checked' , 'true');
                            break;
                    }
                } else if ( $this.is('select') ){
                    if( $this.attr('multiple') ){
                        //$this.data('kendoMultiSelect').value( component[id] );
                        $this.val( component[id] ).trigger('updated');
                    } else {
                        //$this.data('kendoDropDownList').value( component[id] );
                        $this.val( component[id] ).trigger('updated');
                    }
                }
            }
        })
};

fpb.fns.sortSectionComponents = function(event){
    var components = fpb.payload.getSectionComponents( fpb.activeIndx.SECTION , fpb.activeIndx.PAGE );
    var newIndex = event.newIndex;
    var oldIndex = event.oldIndex;
    var iter;
    if( newIndex < oldIndex ){
        var temp = components[newIndex];
        components[newIndex] = components[oldIndex];
        iter = newIndex + 1 ;
        while( iter != oldIndex ) {
            var replace = components[iter];
            components[iter] = temp;
            iter++;
            temp = replace;
        }
        components[iter] = temp;
    }

    if( newIndex > oldIndex ){
        var temp = components[newIndex];
        components[newIndex] = components[oldIndex];
        iter = newIndex - 1 ;
        while( iter != oldIndex ) {
            var replace = components[iter];
            components[iter] = temp;
            iter--;
            temp = replace;
        }
        components[iter] = temp;
    }
};

fpb.fns.initFefPageTab = function(){
    //If no object fields - means that the JSON object was not parsed
    //replace Kendo dropdowns with simple text boxes

    $('#wizardApp').is(':checked') ? $('#addAnotherPage').show() : $('#addAnotherPage').hide();
};

/*
    Triggered after pressing the Add Another Page Button
    Clear out the page definition form and the page section definition
 */
fpb.fns.clearPageForm = function(){
    fpb.fns.clearInputs( $('#pageDefinition') );
    //Clear sections
    $('#sectionList').empty();
};
/*
    Initialize all inputs of a div element
 */
fpb.fns.clearInputs = function($div){
    $div.find('input[type="text"]').each(function(){
        $(this).val('');
    })
    $div.find('input[type="radio"]').each(function(){
        if( $(this).attr('default-check') ){
            $(this).click();
        }
    })
    $div.find('input[type="checkbox"]').each(function(){
        $(this).attr('checked' , false );
    })
};

fpb.fns.parseObjectSchema = function(res){
    var schema_error = $('#schemaError');
    var fields = [];
    var embeddedObjects = [];
    var embeddedObjectFields = [];
    try{
        var dataDictionary = res.DataDictionary;
        var object_json = dataDictionary[ dataDictionary.type ];
        //parse object
        for(var key in object_json ){
            if(key.indexOf('metadata') == -1 & key != 'type'){
                if(key.indexOf('.') > -1 ){
                    var fieldName = key.split('.')[0];
                    if(fields.indexOf(fieldName) == -1 ){
                        fields.push(fieldName);
                    }
                }
                //list
                else if( object_json[key].isCollection ){
                    var type = object_json[key].type;
                    embeddedObjects.push(type);
                    var embedded_json = dataDictionary[type];
                    for(var jkey in embedded_json){
                        if(jkey.indexOf('.') > -1 ){
                            var fieldName = jkey.split('.')[0];
                            if(embeddedObjectFields.indexOf(fieldName) == -1 ){
                                embeddedObjectFields.push(fieldName);
                            }
                        }
                        else{
                            embeddedObjectFields.push(jkey);
                        }
                    }
                }
                else{
                    fields.push(key);
                }
            }
        }
        fpb.objectSchema.fields = fields;
        fpb.objectSchema.lists = embeddedObjects;
        fpb.objectSchema.listFields = embeddedObjectFields;
    }
    catch(err){
        schema_error.text('Object parse failed - missing DataDictionary object').show();
    }
};

fpb.editIconClickFn = function(el){
    var container = $(el).parent();
    var id = container.attr('fa-id');
    var val = container.find(id).text();
    var type = container.attr('fa-fieldtype');
    if( type == 'text' ){
        container.find(id).empty();
        var input_width = Math.round( container.width() * 0.70 );
        container.find(id).append('<input class="k-textbox" style="width:' + input_width + 'px" type="text" value="' + val + '"/>');
        container.find('button').hide();
        $(container.find('button').get(1)).show();
        $(container.find('button').get(2)).show();
    } else if( type == 'boolean'){
        //toggle between true or false - saveIconClickFn will do the toggling
        fpb.saveIconClickFn(el);
    }
};

fpb.saveIconClickFn = function(el){
    var container = $(el).parent();
    var type = container.attr('fa-fieldtype');
    var key = container.attr('fa-replace');
    var newValue;
    if(type == 'text'){
        newValue = container.find('input').val();
    } else if( type == 'boolean'){
        var oldValue = container.find('.fa-inline-code').text();
        switch(oldValue){
            case 'yes' : newValue = 'no'; break;
            case 'no' : newValue = 'yes'; break;
            case 'true' : newValue = 'false'; break;
            case 'false' : newValue = 'true'; break;
        }
    }
    var level = container.attr('fa-level');
    //Save to page
    if( level == 'page' ){
        var curPage = fpb.payload.getPage( fpb.activeIndx.PAGE );
        curPage[key] = newValue;
        container.find('.fa-inline-code').text( newValue );
    } else if ( level == 'section'){
        var curSection = fpb.payload.getSection( fpb.activeIndx.SECTION , fpb.activeIndx.PAGE );
        curSection[key] = newValue;
        container.find('.fa-inline-code').text( newValue );
    }

    container.find('input').remove();
    container.find('button').first().show();
    $(container.find('button').get(1)).hide();
    $(container.find('button').get(2)).hide();
};

fpb.clearInputClick = function(el){
    var container = $(el).parent();

    var level = container.attr('fa-level');
    var key = container.attr('fa-replace');
    if(level == 'page'){
        var page = fpb.payload.getPage( fpb.activeIndx.PAGE );
        container.find('.fa-inline-code').text( page[key] );
    } else if ( level == 'section' ){
        var sec = fpb.payload.getSection( fpb.activeIndx.SECTION , fpb.activeIndx.PAGE );
        container.find('.fa-inline-code').text( sec[key]);
    }

    container.find('input').remove();
    container.find('button').first().show();
    $(container.find('button').get(1)).hide();
    $(container.find('button').get(2)).hide();
};


fpb.saveComponentToSection = function(el){
    var container = $('#componentDetail');
    var component = fpb.payload.getSectionComponent(fpb.activeIndx.SECTION , fpb.activeIndx.PAGE , fpb.activeIndx.COMPONENT );

    container.find('input,select').each(function(){
        var $this = $(this);
        var key = $this.attr('id');
        if( key && $this.is('input') ){
            if( $this.attr('type') == 'checkbox' ){
                component[key] = $this.is(':checked')
            } else {
                component[key] = $this.val();
            }
        } else if ( key && $this.is('select') ){
            component[key] = $this.val();
            /*
            if( $this.attr('multiple') ){
                component[key] = $this.data('kendoMultiSelect').value()
            } else{
                component[key] = $this.data('kendoDropDownList').value()
            }*/
        }
    });
    fpb.fns.addComponentToSectionUI( $('#sectionDefinition').find('ul.fa-section-components') , component );
};

fpb.kvMap = {
    name : 'Name',
    label : 'Label',
    field : 'Field',
    fields : 'Fields',
    inlineEditable : 'Inline-Editable',
    simpleFilter : 'Add Simple Filter',
    formLabel : 'Detail Label',
    tableLabel : 'Master Label',
    tableFields : 'Master Fields',
    formFields : 'Detail Fields'
};

fpb.html.addComponent = function(){
    var component = $('#fefComponents').val();
    //Add it to section list and payload
    var comp_def = { type : component };
    fpb.payload.addSectionComponent(fpb.activeIndx.SECTION ,fpb.activeIndx.PAGE , comp_def );
    fpb.fns.addComponentToSectionUI( $('#sectionDefinition').find('ul.fa-section-components') , comp_def );
    fpb.activeIndx.COMPONENT = comp_def.pk;

    $('#componentDetailDiv').show();

    //Set Component Detail UI
    fpb.fns.setComponentDetail( component , 'Update Component');
};

fpb.fns.setComponentDetail = function( component , btnLabel ){
    //clear components
    var container = $('#componentDetail').empty();
    switch(component){
        case 'core-form' :
            fpb.fns.addComponentInput('label' , 'text');
            fpb.fns.addComponentInput('fields' , 'dropdown-multi' , fpb.objectSchema.fields );
            container.append('<button class="k-button" onclick="fpb.saveComponentToSection(this)" type="core-form">' + btnLabel + '</button>');
            break;
        case 'core-table' :
            fpb.fns.addComponentInput('label' , 'text');
            fpb.fns.addComponentInput('field' , 'dropdown-single' , fpb.objectSchema.lists );
            fpb.fns.addComponentInput('fields' , 'dropdown-multi' , fpb.objectSchema.listFields );
            fpb.fns.addComponentInput('inlineEditable' , 'checkbox');
            container.append('<button class="k-button" onclick="fpb.saveComponentToSection(this)" type="core-table">' + btnLabel + '</button>');
            break;
        case 'core-attachments' :
            fpb.fns.addComponentInput('name' , 'text');
            container.append('<button class="k-button" onclick="fpb.saveComponentToSection(this)" type="core-attachments">' + btnLabel + '</button>');
            break;
        case 'core-list' :
            fpb.fns.addComponentInput('label' , 'text');
            fpb.fns.addComponentInput('field' , 'dropdown-single' , fpb.objectSchema.lists );
            container.append('<button class="k-button" onclick="fpb.saveComponentToSection(this)" type="core-attachments">' + btnLabel + '</button>');
            break;
        case 'core-master-detail' :
            fpb.fns.addComponentInput('field' , 'dropdown-single' , fpb.objectSchema.lists );
            fpb.fns.addComponentInput('formFields' , 'dropdown-multi' , fpb.objectSchema.listFields );
            fpb.fns.addComponentInput('formLabel' , 'text' );
            fpb.fns.addComponentInput('tableFields' , 'dropdown-multi' , fpb.objectSchema.listFields );
            fpb.fns.addComponentInput('tableLabel' , 'text' );
            container.append('<button class="k-button" onclick="fpb.saveComponentToSection(this)" type="core-master-detail">' + btnLabel + '</button>');
            break;
    }

    $('#componentDetailType').text( component );
};

fpb.fns.addComponentInput = function( id , type , list ){
    var componentDetail = $('#componentDetail');
    if( type == 'text' ){
        var container = $('<div class="fa-form-input">' +
            '<label>' + fpb.kvMap[id]  + '</label>' +
            '<input type="text" class="k-textbox" id="' + id + '"/>' +
            '</div>'
        );
        componentDetail.append(container);
    }
    if( type == 'dropdown-multi' ){
        //If list - means that the user imported an object schema - add select
        //If not - just add a text box
        if(list && list.length){
            var container = $('<div class="fa-form-input">')
                .append('<label for="' + id + '" class="label">' + fpb.kvMap[id] + '</label>');
            var select = $('<select multiple id="' + id + '" class="dropdown" data-maxselected="20"/>');
            list.forEach( function(item){
               select.append('<option value="' + item + '">' + item + '</option>');
            });
            container.append(select);
            componentDetail.append(container);
            componentDetail.find('#' + id).multiselect();
        } else{
            fpb.fns.addComponentInput(id , 'text');
        }
    }
    if( type == 'dropdown-single' ){
        if(list && list.length){
            var container = $('<div class="fa-form-input">')
                .append('<label for="' + id + '" class="label">' + fpb.kvMap[id] + '</label>');
            var select = $('<select id="' + id + '" class="dropdown"/>');
            list.forEach( function(item){
                select.append('<option value="' + item + '">' + item + '</option>');
            });
            container.append(select);
            componentDetail.append(container);
            componentDetail.find('#' + id).dropdown();
        } else{
            fpb.fns.addComponentInput(id , 'text' );
        }
    }
    if( type == 'checkbox' ){
        var container = $('<div class="fa-form-input">' +
            '<label>' + fpb.kvMap[id] + '</label>' +
            '<div class="field fa-checkbox">' +
            '<input type="checkbox" id="' + id + '" class="checkbox"/>' +
            '<label for="' + id + '" class="checkbox-label"/>' +
            '</div>'
        );
        componentDetail.append(container);
    }
};

fpb.showPageReviewScreen = function(){
    fpb.fns.setTabThreeMode('REVIEW');
    $('#pageTree').data('kendoTreeView').setDataSource ( fpb.payload.getPagesForTreeDataSource() );
    fpb.payload.isWizardApp() ? $('#addAnotherPage').show() : $('#addAnotherPage').hide();
    //Add edit button to page headers in tree
    fpb.fns.appendPageEditBtns();
};

fpb.fns.appendPageEditBtns = function(){
    $('h3[index]')
        .each( function(){
            var editBtn = $('<button class="btn-icon" onclick="fpb.editPage(this)">' +
                '<svg role="presentation" aria-hidden="true" focusable="false" class="icon" xmlns:xlink="http://www.w3.org/1999/xlink">' +
                '<use xlink:href="#icon-edit"/></svg></button>');
            $(this).append(editBtn);
        })
};

fpb.editPage = function(el){
    var pageId = $(el).parent('h3').attr('index');
    var page = fpb.payload.getPage( pageId );
    fpb.fns.setEditablePage( page , pageId );
};

fpb.fns.setTabThreeMode = function( mode ){
    switch( mode ){
        case 'ADD_NEW' :
            var div = $('#pageDefinition').show();
            fpb.fns.clearInputs( div );
            $('#reviewPanel, #activePageDefinition, #componentDetailDiv').hide();
            break;
        case 'REVIEW' :
            $('#pageDefinition , #activePageDefinition').hide();
            $('#reviewPanel').show();
            break;
        case 'EDITABLE' :
            $('#activePageDefinition').show();
            $('#reviewPanel , #pageDefinition').hide();
            break;
    }
    if( mode == 'REVIEW'){
        $('#continueBtn3').show();
        $('#reviewBtn').hide();
    } else {
        $('#continueBtn3').hide();
        $('#reviewBtn').show();
    }
};

//attach to window
window.fpb = fpb;

module.exports = fpb;


// WEBPACK FOOTER //
// ./public/javascripts/GTNexus.FEF-Page-Builder.js